import { CreditorData } from './CreditorData';
import { UserProfile } from './UserProfile';

export type UserType =
  | 'ADMIN'
  | 'MANAGER'
  | 'FINANCIAL'
  | 'CREDITOR'
  | 'DEBTOR';
export type User = {
  email: string;
  isVerified: boolean;
  type: UserType;
  profile: UserProfile;
  creditorData?: CreditorData;
  publicId: string;
  createdAt: string;
  updatedAt: string;
};

export class UserEntity {
  userData: User;

  constructor(userData: User) {
    this.userData = userData;
  }

  isContractSigned() {
    return this.userData.creditorData?.contractSigned;
  }

  isCreditorValidated() {
    return this.isCreditorStatus('VALIDATED');
  }
  isCreditorCreated() {
    return this.isCreditorStatus('CREATED');
  }
  isCreditorCompleted() {
    return this.isCreditorStatus('COMPLETED');
  }

  isCreditorStatus(status: string) {
    if (this.userData?.type === 'CREDITOR') {
      return this.userData?.creditorData?.status === status;
    }
    return true;
  }

  getUserType() {
    return this.userData?.type;
  }

  isUserInternal() {
    return ['ADMIN', 'MANAGER', 'FINANCIAL'].includes(this.userData?.type);
  }

  isUserCreditor() {
    return ['CREDITOR'].includes(this.userData?.type);
  }
  isUserDebtor() {
    return ['DEBTOR'].includes(this.userData?.type);
  }

  isUserAdmin() {
    return ['ADMIN'].includes(this.userData?.type);
  }

  isUserContractVisible() {
    if (this.isUserInternal()){
        return true;
    }
    return !this.isCreditorStatus('CREATED');
  }
}
